import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fi from "./locales/fi.json";
import en from "./locales/en.json";

// Languages offered in the switcher, in display order. fi.json is the
// source of truth; every other locale must have the same keys (checked
// by i18n.test.ts). To add a language, add locales/<code>.json, import
// it into `resources` and list it here.
export const SUPPORTED_LANGUAGES = [
  { code: "fi", label: "Suomi" },
  { code: "en", label: "English" },
] as const;

export const resources = {
  fi: { translation: fi },
  en: { translation: en },
} as const;

type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

// How `{{value, date}}` renders a Date in each language: Finnish 30.11.2026,
// English 30 November 2026.
export const DATE_FORMATS: Record<LanguageCode, Intl.DateTimeFormat> = {
  fi: new Intl.DateTimeFormat("fi-FI", { day: "numeric", month: "numeric", year: "numeric" }),
  en: new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long", year: "numeric" }),
};

// The app always starts in Finnish; the switcher changes the language for
// the current page load only (no detection or persistence).
i18n.use(initReactI18next).init({
  resources,
  lng: "fi",
  fallbackLng: "fi",
  // React already escapes rendered strings
  interpolation: { escapeValue: false },
});

i18n.services.formatter?.add("date", (value: Date, lng) =>
  (DATE_FORMATS[lng as LanguageCode] ?? DATE_FORMATS.fi).format(value),
);

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
